import { Chip } from '@mui/material'
import type { GroupStatus } from '@/types'
import { useEnumsStore } from '@/stores/enumsStore'

interface GroupStatusBadgeProps {
  status: GroupStatus
  label?: string
}

const statusConfig: Record<string, { color: 'success' | 'default' }> = {
  active: { color: 'success' },
  archived: { color: 'default' },
}

export function GroupStatusBadge({ status, label: labelProp }: GroupStatusBadgeProps) {
  const enums = useEnumsStore((state) => state.enums)
  const labelFromEnums = enums?.GroupStatus?.find((o) => o.value === status)?.label
  const displayLabel = labelProp ?? labelFromEnums ?? status
  const config = statusConfig[status] ?? { color: 'default' as const }
  return (
    <Chip
      label={displayLabel}
      color={config.color}
      size="small"
    />
  )
}
